import React from 'react';

const Contact = () => {
    return (
        <>
            <p className="section-heading">
                <strong>Contact</strong>
            </p>
            <p>
                <a href="https://github.com/lanpouthakoun">GitHub</a> &middot;{' '}
                <a href="mailto:andlanpo@stanford.edu">Email</a> &middot;{' '}
                <a href="https://scholar.google.com/citations?user=0hrwmO0AAAAJ&hl=en">
                    Google Scholar
                </a>{' '}
                &middot; <a href="https://x.com/aslanpouthakoun">X</a>
            </p>
        </>
    );
};

export default Contact;
